import { createContext, useState } from "react";
import { formatDate } from "../../../../utils/formatDate";

const ConciliacaoUploadContext = createContext();

const ConciliacaoUploadContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [bankAgencies, setBankAgencies] = useState([]);
  const [status, setStatus] = useState({ label: "Todos", value: "" });
  const [dateFrom, setDateFrom] = useState({
    label: "Extrato",
    value: "extrato",
  });
  const [bankAccount, setBankAccount] = useState(null);

  const [initialDate, setInitialDate] = useState(
    formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
  );

  const [finalDate, setFinalDate] = useState(
    formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
  );

  const [historicDataTable, setHistoricDataTable] = useState([]);
  const [pagePropDefault, setPagePropDefault] = useState(0);
  const [openFinanceDataTable, setOpenFinanceDataTable] = useState([]);

  return (
    <ConciliacaoUploadContext.Provider
      value={{
        loading,
        setLoading,
        bankAgencies,
        setBankAgencies,
        status,
        setStatus,
        dateFrom,
        setDateFrom,
        bankAccount,
        setBankAccount,
        initialDate,
        setInitialDate,
        finalDate,
        setFinalDate,
        historicDataTable,
        setHistoricDataTable,
        pagePropDefault,
        setPagePropDefault,
        openFinanceDataTable,
        setOpenFinanceDataTable,
      }}
    >
      {children}
    </ConciliacaoUploadContext.Provider>
  );
};

export { ConciliacaoUploadContextProvider, ConciliacaoUploadContext };
